import { useState, type ReactElement } from 'react';

import type { CloudApi } from '../api/client';
import { errorMessage } from '../api/client';

interface LogoutButtonProps {
  readonly api: Pick<CloudApi, 'logout'>;
  readonly onLoggedOut: () => void;
}

export function LogoutButton({ api, onLoggedOut }: LogoutButtonProps): ReactElement {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const logout = async (): Promise<void> => {
    setBusy(true);
    setError(null);
    try {
      await api.logout();
      onLoggedOut();
    } catch (reason) {
      // Do not present a logged-out UI until the server revoked the session.
      setError(errorMessage(reason));
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className="logout-control">
      <button type="button" className="secondary" disabled={busy} onClick={() => void logout()}>
        {busy ? '登出中…' : '登出'}
      </button>
      {error !== null && <span className="logout-error" role="alert">{error}</span>}
    </span>
  );
}
